import { FilterContext } from "core/context/FilterContext";
import { useContext } from "react";

export function useMainContentFilter() {
  return useContext(FilterContext);
}
